<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div>

		<a-form layout="inline">
			<a-form-item label="标准名称">
				<a-input  v-model="filterData.keywords" placeholder="请输入标准名称/ID" />
			</a-form-item>
			<a-form-item label="标准编号">
				<a-input  v-model="filterData.standardCode" placeholder="请输入标准编号" />
			</a-form-item>
			<a-form-item label="执行状态">
				<a-select  style="width: 200px" v-model="filterData.implementationStatus" class="mr12"
					placeholder="请选择执行状态" show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of commodityStatusList" :key="index" :value="item.value">
						{{ item.label }}
					</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>

				<a-button class="mr12" v-if="hasPermission('EXECUTIONSTANDARD_SCRIPT')" @click="scriptEdit">话术编辑</a-button>
				<a-button class="mr12" v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('EXECUTIONSTANDARD_IMPORT')" @click="importExcel">导入</a-button>
				<a-button v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('EXECUTIONSTANDARD_ADD')" @click="toAdd" type="primary">新建标准</a-button>
			</a-form-item>
		</a-form>

		<div style="margin-top: 16px;margin-bottom: 16px;">
			<a-radio-group v-model="filterData.tagId" button-style="solid" @change="changeTab">
				<!-- 全部选项,value为空,筛选时不传tagId -->
				<a-radio-button style="width: 150px;text-align: center;" value="">全部</a-radio-button>
				<!-- 循环后端tags数组,动态生成单选按钮 -->
				<a-radio-button style="width: 150px;text-align: center;" v-for="item in tags" :key="item.tagId" :value="item.tagId">
					{{ item.tagName }}
				</a-radio-button>
			</a-radio-group>
		</div>

		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<!-- 执行状态 -->
			<!-- ACTIVE-现行有效 PENDING-即将实施 OBSOLETE-已废止 -->
			<template slot="implementationStatusRender" slot-scope="text, record">
				<a-tag color="#2db7f5" v-if="record.implementationStatus == 'ACTIVE'">
					现行有效
				</a-tag>
				<a-tag color="#87d068" v-else-if="record.implementationStatus == 'PENDING'">
					即将实施
				</a-tag>
				<a-tag  v-else-if="record.implementationStatus == 'OBSOLETE'">
					已废止
				</a-tag>
				<a-tag v-else></a-tag>
			</template>
			<!-- 发布状态 1 2-->
			<template slot="standardStatusRender" slot-scope="text, record">
				<div style="display: flex;align-items: center;">
					<a-switch :checked="!!record.standardStatus"
						@change="(checked) => handlePublishChange(checked, record)" />
					<a-tag style="margin-left: 10px;" color="#2db7f5" v-if="record.standardStatus == true">
						启用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else-if="record.standardStatus == false">
						禁用
					</a-tag>
					<a-tag style="margin-left: 10px;" v-else></a-tag>
				</div>

			</template>
			<template slot="indexSortender" slot-scope="text, record">
				<a-input v-model.number="record.sort" placeholder="排序" type="number" @blur="handleSaveSort(record)"
					@keyup.enter="handleSaveSort(record)" /></template>
			<!-- 编辑,删除 -->
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<span v-if="hasPermission('EXECUTIONSTANDARD_EDIT')"><a-button type="link" @click="toEdit(record)">编辑</a-button></span>
                <a-popconfirm title="你确定删除这条信息吗?" okText="确定" cancelText="取消" @confirm="sureDelete(record)">
						<a-button type="link" v-if="filterData.lang !== 'EN' &amp;&amp; hasPermission('EXECUTIONSTANDARD_DEL')">删除</a-button>
					</a-popconfirm>
				</div>
			</template>

		</a-table>
		<a-modal :title="editModel.title" :visible="editModel.flag" width="700px" @ok="editModel.onOk"
			@cancel="handleModalCancel">
			<!-- :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" -->
			<a-form-model class="execution-form" ref="formRef" :model="editModel" :rules="rules">
				<a-row :gutter="12">
					<a-col :span="12">
						<a-form-model-item label="标准编号" prop="standardCode" required>
							<a-input  v-model="editModel.standardCode" placeholder="请输入标准编号" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="标准分类" prop="tagId" required>
							<a-select  v-model="editModel.tagId" placeholder="请选择" show-search
								option-filter-prop="name" :filter-option="filterOption">
								<a-select-option v-for="(item, index) of tags" :key="index" :value="item.tagId">
									{{ item.tagName }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 第二行:标准名称 通栏 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="标准名称" prop="standardName" required>
							<a-input  v-model="editModel.standardName" placeholder="请输入标准名称" />
						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 第三行:颁发部门 输入框+添加按钮 + 标签列表 todo -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item
						:validateStatus="deptListError ? 'error' : ''"
						:help="deptListError ? '请添加颁发部门' : ''">
							<span slot="label"> <span style="color:#f5222d;    font-size: 14px;">* </span>颁发部门</span>

							<div style="display: flex;">
								<a-input  v-model="deptText" placeholder="请添加颁发部门" />
								<a-button style="width: 100px;margin-left: 12px;" type="primary" @click="addDept">+
									新增</a-button>
							</div>

							<div ref="dragContainer" style="width: 100%;">
								<div class="size_item" v-for="(item,idx) of deptList" :key="item" :data-sort-index="idx">
									<span class="drag-handle" style="cursor:grab;margin-right:6px;flex-shrink:0;user-select:none;" title="拖拽排序">⠿</span>
									<span class="left">{{ item }}</span>
									<a-icon class="right" type="delete" style="color:red;cursor:pointer"
										@click="deleteDept(idx)" />
								</div>
							</div>

						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 第四行:实施日期 + 状态 -->
				<a-row :gutter="12">
					<a-col :span="12">
						<a-form-model-item label="实施日期" prop="implementationDate" required>
							<a-date-picker  v-model="editModel.implementationDate" format="YYYY-MM-DD"
								valueFormat="YYYY-MM-DD" placeholder="请选择日期" style="width: 100%;" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="状态" prop="implementationStatus" required>
							<a-select  v-model="editModel.implementationStatus" placeholder="请选择状态">
								<a-select-option value="ACTIVE">现行有效</a-select-option>
								<a-select-option value="PENDING">即将实施</a-select-option>
								<a-select-option value="OBSOLETE">已废止</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 适用范围 textarea 字数限制 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="适用范围" prop="scopeOfApplication" required>
							<a-textarea  v-model="editModel.scopeOfApplication" :max-length="500" show-count rows="4"
								placeholder="请输入适用范围" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 标准说明 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="标准说明" prop="standardDescription" required>
							<a-textarea v-model="editModel.standardDescription" rows="3" placeholder="请输入标准说明" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 标准说明（otherStand 子项） -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="">
							<div style="display:flex;margin-bottom:8px;">
								<a-button   type="primary" @click="addOtherStand">+ 添加子项</a-button>
							</div>
							<div ref="dragContainerOtherStand">
									<div v-for="(item, idx) of otherStandList" :key="item._sortKey || idx" :data-sort-index="idx"
										style="border:1px solid #d9d9d9;border-radius:4px;padding:12px;margin-bottom:8px;" :data-key="item._sortKey">
										<div style="display:flex;align-items:flex-start;gap:8px;margin-bottom:8px;">
											<div class="drag-handle" style="cursor:grab;padding:6px 4px;display:flex;flex-direction:column;gap:3px;margin-top:6px;flex-shrink:0;user-select:none;" title="拖拽排序">
												<div style="width:18px;height:2px;background:#bbb;border-radius:1px;"></div>
												<div style="width:18px;height:2px;background:#bbb;border-radius:1px;"></div>
												<div style="width:18px;height:2px;background:#bbb;border-radius:1px;"></div>
											</div>
											<div style="flex:1;min-width:0;">
												<a-input v-model="item.title" placeholder="标题" style="width:100%;" />
											</div>
											<div style="flex-shrink:0;display:flex;align-items:center;gap:4px;padding-top:4px;">
												<label style="cursor:pointer;display:flex;align-items:center;">
													<span style="font-size:12px;color:#666;">颜色</span>
													<input type="color" v-model="item.color" style="width:28px;height:28px;padding:0;border:none;cursor:pointer;vertical-align:middle;" />
												</label>
												<a-icon type="delete" style="color:red;cursor:pointer;font-size:18px;" @click="deleteOtherStand(idx)" />
											</div>
										</div>
										<a-textarea v-model="item.content" rows="3" placeholder="编辑内容" style="width:100%;" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 第三行:主要理化指标 输入框+添加按钮 + 标签列表 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="主要理化指标" prop="deptText">
							<div style="display: flex;">
								<a-input v-model="mainText" placeholder="请输入主要理化指标" />
								<a-button style="width: 100px;margin-left: 12px;" type="primary" @click="addMain">+
									新增</a-button>
							</div>
							<div ref="dragContainerMain" style="width: 100%;">
								<div class="size_item" v-for="(item,idx) of mainList" :key="item" :data-sort-index="idx">
									<span class="drag-handle" style="cursor:grab;margin-right:6px;flex-shrink:0;user-select:none;" title="拖拽排序">⠿</span>
									<span class="left">{{ item }}</span>
									<a-icon class="right" type="delete" style="color:red;cursor:pointer"
										@click="deletemain(idx)" />
								</div>
							</div>

						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 自定义内容 -->
				<!-- 富文本 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="自定义内容" prop="customContent">
							<div ref="wangEditorCustom"></div>
						</a-form-model-item>
					</a-col>
				</a-row>

				<!-- 标准文件 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item
							:validateStatus="standardDocError ? 'error' : ''"
							:help="standardDocError ? '请上传标准文件' : ''">
						<span slot="label"> <span style="color:#f5222d;font-size: 14px;">* </span>标准文件 </span>
							<div style="display: flex;align-items: center;">
								<div style="display: flex;align-items: center;">
									<div v-if="editModel.standardDocument">
									{{editModel.standardDocument}}
								</div>
								</div>

								<div class="again_upload_box ml12">
									<input type="file" accept=".pdf" @change="handleUploadThumbnail" :disabled="uploading" />
									<i class="el-icon-box again_upload_icon"></i>
									<div class="bold" style="width: 100px">
										<a-spin v-if="uploading" />
										<span v-else>{{ editModel.standardDocument ? "重新上传" : "选择上传文件" }}</span>
									</div>
								</div>
							</div>
							<div>只能上传PDF格式文件，文件不能超过10M</div>

						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- 发布状态 -->
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="发布状态" prop="standardStatus">
							<a-switch :checked="editModel.standardStatus"
								@change="(checked) => handleSwitch(checked)" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row :gutter="12">
					<a-col :span="12">
						<a-form-model-item label="废止日期" prop="obsolescenceDate">
							<a-date-picker  v-model="editModel.obsolescenceDate" format="YYYY-MM-DD"
								valueFormat="YYYY-MM-DD" placeholder="请选择日期" style="width: 100%;" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="排序" prop="sort">
							<a-input  v-model.number="editModel.sort" placeholder="显示顺序" />
						</a-form-model-item>
					</a-col>
				</a-row>

			</a-form-model>
		</a-modal>


		<a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>底部内容</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-textarea v-model="tipsModel.bottomContent" placeholder="内容" :rows="3" /></div>
		</a-modal>

		<!-- 导入弹窗 -->
		<a-modal title="导入执行标准" :visible="importModel.flag" width="500px" :footer="null" @cancel="importModel.flag = false">
			<div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
				<a-button type="link" @click="handleDownloadTemplate">下载导入模板</a-button>
				<div class="import-upload-area" @click="triggerFileSelect" style="width: 100%; min-height: 160px; border: 2px dashed #d9d9d9; border-radius: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; background: #fafafa;">
					<div style="font-size: 48px; color: #40a9ff; line-height: 1;">+</div>
					<div style="margin-top: 8px; color: #666;">点击选择 Excel 文件</div>
					<div style="margin-top: 4px; font-size: 12px; color: #999;">支持 .xlsx 格式</div>
				</div>
				<input ref="importFileInput" type="file" accept=".xlsx" style="display: none" @change="handleImport" />
				<div v-if="importModel.selectedFile" style="color: #333;">
					已选择：{{ importModel.selectedFile.name }}
				</div>
				<a-button v-if="importModel.selectedFile" type="primary" :loading="importModel.uploading" @click="handleUpload">
					开始导入
				</a-button>
			</div>
		</a-modal>

		<a-modal title="导入结果" :visible="importModel.resultVisible" width="500px" :footer="null" @cancel="importModel.resultVisible = false">
			<div style="padding: 16px 0;" v-if="importModel.resultData">
				<div v-if="importModel.resultData.fileUrl" style="margin-bottom: 16px; padding: 12px; background: #fff2f0; border: 1px solid #ffccc7; border-radius: 4px;">
					<div style="color: #ff4d4f; margin-bottom: 8px;">部分数据导入失败，请下载错误文件查看详情：</div>
					<a-button type="primary"  @click="downloadErrorFile(importModel.resultData.fileUrl)">
						下载错误文件
					</a-button>
				</div>
				<div style="text-align: center;">
					<a-button @click="importModel.resultVisible = false">关闭</a-button>
				</div>
			</div>
		</a-modal>

	</div>
</template>

<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import Sortable from 'sortablejs'
	import E from 'wangeditor'
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getTagCategoriesApi,
		importExecutionStandardApi, // 导入
		getExecutionStandardListApi, //  执行标准列表
		getExecutionStandardDetailApi, //  执行标准详情
		saveExecutionStandardApi, //  执行标准新增/编辑
		deleteExecutionStandardApi, //    执行标准删除
		updateExecutionStandardStatusApi, //  执行标准 修改状态
		updateExecutionStandardSortApi, //  修改排序
			getBottomWordingApi, // 页面话术编辑 获取
		saveBottomWordingApi, // 页面话术编辑 保存
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editor: null,
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'],
							['clean']
						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				commodityStatusList: [{
						label: "现行有效",
						value: 'ACTIVE',
					},
					{
						label: "即将实施",
						value: 'PENDING',
					},
					{
						label: "已废止",
						value: 'OBSOLETE',
					},
				],
				columns: [{
						title: 'ID',
						dataIndex: 'executionStandardCode',
						key: 'executionStandardCode',
					},
					{
						title: '标准编号',
						dataIndex: 'standardCode',
						key: 'standardCode',
					},
					{
						title: '标准名称',
						dataIndex: 'standardName',
						key: 'standardName',
					},
					{
						title: '分类',
						dataIndex: 'tagName',
						key: 'tagName',
					},
					{
						title: '实施日期',
						dataIndex: 'implementationDate',
						key: 'implementationDate',
					},
					{
						title: '执行状态',
						dataIndex: 'implementationStatus',
						key: 'implementationStatus',
						scopedSlots: {
							customRender: 'implementationStatusRender'
						},
					},
					{
						title: '发布状态',
						dataIndex: 'standardStatus',
						key: 'standardStatus',
						scopedSlots: {
							customRender: 'standardStatusRender'
						},
					},
					{
						title: '排序',
						dataIndex: 'sort',
						key: 'sort',
						scopedSlots: {
							customRender: 'indexSortender'
						},
					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					bottomTitle: "",
					bottomContent: "",
					type: 'STANDAR',
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					executionStandardId: '',
					executionStandardCode: '',
					standardCode: '',
					tagId: undefined,
					tagName: '',
					lang: '',
					standardName: '',
					issuingAuthority: '',
					implementationStatus: '',
					standardStatus: false,
					sort: null,
					scopeOfApplication: '',
					standardDescription: '',
					otherStand: '',
					physicochemicalIndicators: '',
					customContent: '',
					standardDocument: '',
					standardId: '',
					implementationDate: null,
					createTime: '',
					onOk: () => {},
				},
				formState: {
					"iconUrl": "",
					"name": "",
					"sort": 1
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					keywords: "",
					standardCode: "",
					implementationStatus: undefined,
					lang: "CH",
					tagId: ''
				},
				tags: [],
				deptText: "",
				deptList: [],
				mainText: "",
				mainList: [],
				otherStandList: [],
				deptListError: false,
				standardDocError: false,
				uploading: false,
				rules: {
					standardCode: [{ required: true, message: '请输入标准编号', trigger: 'blur' }],
					tagId: [{ required: true, message: '请选择标准分类', trigger: 'change' }],
					standardName: [{ required: true, message: '请输入标准名称', trigger: 'blur' }],
					implementationDate: [{ required: true, message: '请选择实施日期', trigger: 'change' }],
					implementationStatus: [{ required: true, message: '请选择状态', trigger: 'change' }],
					scopeOfApplication: [{ required: true, message: '请输入适用范围', trigger: 'blur' }],
					standardDescription: [{ required: true, message: '请输入标准说明', trigger: 'blur' }],
					standardDocument: [{ required: true, message: '请上传标准文件' }],
				},
				importModel: {
					flag: false,
					selectedFile: null,
					uploading: false,
					resultVisible: false,
					resultData: null,
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('executionStandard_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
				this.filterData.lang = 'CH';
			}
			this.getData(1)
			this.getTagsLabel()
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('executionStandard_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			hasPermission(permission) {
				const resources = this.$store.state.userInfo.resources;
				return resources && resources.split(";").includes(permission);
			},
			// Sortable 拖拽
			initAllDrag() {
				this.$nextTick(() => {
					this.createDrag('dragContainer', this.deptList);
					this.createDrag('dragContainerMain', this.mainList);
					this.createDrag('dragContainerOtherStand', this.otherStandList);
				});
			},
			createDrag(refName, list) {
				const el = this.$refs[refName];
				if (!el) return;
				if (el._sortableInstance) el._sortableInstance.destroy();
				el._sortableInstance = Sortable.create(el, {
					animation: 150,
					ghostClass: 'sort-ghost',
					handle: '.drag-handle',
					onEnd: (evt) => {
						if (list.length > 0 && list[0]._sortKey !== undefined) {
							const domOrder = Array.from(el.children).map(child =>
								child.dataset.key
							).filter(Boolean);
							if (domOrder.length === list.length) {
								const reordered = domOrder.map(k =>
									list.find(item => String(item._sortKey) === k)
								).filter(Boolean);
								if (reordered.length === list.length) {
									list.splice(0, list.length, ...reordered);
								}
							}
						} else {
							const { oldIndex, newIndex } = evt;
							const moveItem = list.splice(oldIndex, 1)[0];
							list.splice(newIndex, 0, moveItem);
						}
					}
				});
			},
			// wangEditor 初始化
			initEditor() {
				if (!this.$refs.wangEditorCustom) return;
				if (this.editor) {
					this.editor.destroy();
					this.editor = null;
				}
				this.editor = new E(this.$refs.wangEditorCustom);
				this.editor.config.height = 300;
				this.editor.config.customUploadImg = (files, insert) => {
					files.forEach(file => {
						if (file.size > 3 * 1024 * 1024) {
							this.$message.error(file.name + ' 超过3MB限制');
							return;
						}
						ossUpload(file, '', 'image/').then(res => {
							insert(res.url);
						}).catch(() => {
							this.$message.error('图片上传失败');
						});
					});
				};
				this.editor.config.onchange = (html) => {
					this.editModel.customContent = html;
				};
				this.editor.create();
				if (this.editModel.customContent) {
					this.editor.txt.html(this.editModel.customContent);
				}
			},
			// 模态框取消
			handleModalCancel() {
				if (this.editor) {
					this.editor.destroy();
					this.editor = null;
				}
				this.editModel.flag = false;
			},
			// otherStand 子项管理
			addOtherStand() {
				if (this.otherStandList.length > 0) {
					const last = this.otherStandList[this.otherStandList.length - 1];
					if (!last.title || !last.content) {
						this.$message.warning('请先填写上一个子项的标题和内容');
						return;
					}
				}
				this.otherStandList.push({
					_sortKey: Date.now() + Math.random(),
					title: '',
					content: '',
					color: '#FF0000'
				});
			},
			deleteOtherStand(idx) {
				this.otherStandList.splice(idx, 1);
			},
			// 切换发布状态(带确认提示)
			handlePublishChange(checked, record) {
				// 动态生成提示文案
				let content = '';
				if (checked) {
					content = '切换为启用状态,则当前数据用户前端可查看,确认变更当前数据状态?';
				} else {
					content = '切换为禁用状态,则当前数据前端不可查看,确认变更当前数据状态?';
				}
				this.$confirm({
					title: '操作确认',
					content: content,
					okText: '确定',
					cancelText: '取消',
					onOk: () => {
						this.updateStatusApi(record.executionStandardId)
						console.log('发布状态已更新为:', record.standardStatus);
					},
					onCancel: () => {
						console.log('已取消操作');
					}
				});
			},
			updateStatusApi(executionStandardId) {
				updateExecutionStandardStatusApi({
						executionStandardId: executionStandardId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								"修改成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData(this.pageInfo.current)
					})
			},

			// 保存排序(输入框回车/失焦触发)
			handleSaveSort(record) {
				if (record.sort === undefined || record.sort === null || record.sort === '') {
					return
				}
				updateExecutionStandardSortApi({
					executionStandardId: record.executionStandardId,
					sort: record.sort
				}).then(res => {
					if (res.resultStatus) {
						this.$message.success('排序保存成功')
						this.getData(this.pageInfo.current)
					} else {
						this.$message.error('保存失败')
					}
				}).catch(err => {
					this.$message.error('保存失败')
				})
			},
			toDownload(data) {
				this.$downLoadFile(data, '标准文件');
			},

			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1);
			},

			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1);
			},
			deleteDept(index) {
				this.deptList.splice(index, 1);
			},
			addDept() {
				if (!this.deptText) return;
				this.deptList.push(this.deptText);
				this.deptText = '';
				this.deptListError = false;
			},
			deletemain(index) {
				this.mainList.splice(index, 1);
			},
			addMain() {
				if (!this.mainText) return;
				this.mainList.push(this.mainText);
				this.mainText = '';
			},
			getTagsLabel() {
				getTagCategoriesApi({
					tagTypeCategory: 'EXECUTION_STANDARD'
				}).then((res) => {
					if (res.resultStatus) {
						this.tags = res.resultData[0].tags
					} else {}
				})
			},
			handleCategoryChange() {
				this.pageInfo.current = 1;
				this.loadTableData();
			},
			handleSwitch(checked) {
				this.editModel.standardStatus = checked
			},

			handleBlur() {
				console.log('blur');
			},
			handleFocus() {
				console.log('focus');
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					this.filterData = {
						keywords: "",
						standardCode: "",
						lang: "CH",
						implementationStatus: undefined,
						tagId: ''
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getExecutionStandardListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						lang: this.filterData.lang,
						keywords: this.filterData.keywords,
						standardCode: this.filterData.standardCode,
						tagId: this.filterData.tagId,
						implementationStatus: this.filterData.implementationStatus,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				if (this.$refs.formRef) {
					this.$refs.formRef.clearValidate();
				}

				if (this.editor) {
					this.editor.destroy();
					this.editor = null;
				}
				this.editModel = {
					flag: true,
					title: "新建标准",
					executionStandardId: '',
					executionStandardCode: '',
					standardCode: '',
					tagId: this.filterData.tagId || undefined,
					tagName: '',
					lang: '',
					standardName: '',
					issuingAuthority: '',
					implementationStatus: undefined,
					standardStatus: false,

					scopeOfApplication: '',
					standardDescription: '',
					otherStand: '',
					physicochemicalIndicators: '',
					customContent: '',
					standardDocument: '',
					standardId: '',
					implementationDate: null,
					createTime: '',
					sort: null,
					onOk: this.sureEdit,
				};
				this.otherStandList = [];
				this.deptList = [];
				this.mainList = [];
				this.deptText = '';
				this.mainText = '';
				this.deptListError = false;
				this.standardDocError = false;
				this.$nextTick(() => {
					this.initAllDrag();
					this.initEditor();
				});
			},
			toEdit(data) {
				this.deptListError = false;
				this.standardDocError = false;
				if (this.$refs.formRef) {
					this.$refs.formRef.clearValidate();
				}

				getExecutionStandardDetailApi({
						executionStandardId: data.executionStandardId,
					})
					.then((res) => {
						if (res.resultStatus) {
							console.log(res.resultData, '看看返回的结果')
							const result = res.resultData;
							this.editModel = {
								"flag": true,
								"title": "编辑标准",
								executionStandardId: result.executionStandardId ?? '',
								executionStandardCode: result.executionStandardCode ?? '',
								standardCode: result.standardCode ?? '',
								tagId: result.tagId ?? '',
								tagName: result.tagName ?? '',
								lang: result.lang ?? '',
								standardName: result.standardName ?? '',
								issuingAuthority: result.issuingAuthority ?? '',
								implementationStatus: result.implementationStatus ?? '',
								standardStatus: result.standardStatus ?? '',
								sort: result.sort ?? null,
								scopeOfApplication: result.scopeOfApplication ?? '',
								standardDescription: result.standardDescription ?? '',
								otherStand: result.otherStand ?? '',
								physicochemicalIndicators: result.physicochemicalIndicators ?? '',
								customContent: result.customContent ?? '',
								standardDocument: result.standardDocument ?? '',
								standardId: result.standardId ?? '',
								implementationDate: result.implementationDate ?? null,
								obsolescenceDate: result.obsolescenceDate ?? null,
								createTime: result.createTime ?? '',
								onOk: this.sureEdit,
							};
							// 拆分 issuingAuthority 到 deptList
							if (result.issuingAuthority) {
								this.deptList = result.issuingAuthority.split(';').filter(Boolean);
							} else {
								this.deptList = [];
							}
							// 拆分 physicochemicalIndicators 到 mainList
							if (result.physicochemicalIndicators) {
								this.mainList = result.physicochemicalIndicators.split(';').filter(Boolean);
							} else {
								this.mainList = [];
							}
							// 解析 otherStand JSON 到 otherStandList
							if (result.otherStand) {
								try {
									this.otherStandList = JSON.parse(result.otherStand);
								} catch(e) {
									this.otherStandList = [];
								}
							} else {
								this.otherStandList = [];
							}
							this.$nextTick(() => {
								this.initAllDrag();
								this.initEditor();
							});
						} else {
							console.log("res");
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			confirm() {

			},
			sureScript(data) {
				const configValue = JSON.stringify({
					bottomTitle: this.tipsModel.bottomTitle,
					bottomContent: this.tipsModel.bottomContent,
				});
				const params = {
					configId: this.tipsModel.configId,
					configValue,
					type: 'STANDAR',
					lang: this.filterData.lang || 'CH',
				};
				saveBottomWordingApi(params).then((res) => {
					if (res.resultStatus) {
						this.$message.success('保存成功');
						this.tipsModel.flag = false;
					}
				}).catch((err) => {
					console.log(err);
					this.$message.error('保存失败');
				});
			},
			// 话术编辑
			scriptEdit() {
				const lang = this.filterData.lang || 'CH';
				getBottomWordingApi({ type: 'STANDAR', lang }).then((res) => {
					if (res.resultStatus) {
						const data = res.resultData || {};
						let parsed = { bottomTitle: '', bottomContent: '' };
						if (data.configValue) {
							try {
								parsed = JSON.parse(data.configValue);
							} catch(e) {
								console.log(e);
							}
						}
						this.tipsModel = {
							flag: true,
							title: '执行标准页面话术编辑',
							configId: data.configId,
							bottomTitle: parsed.bottomTitle || '',
							bottomContent: parsed.bottomContent || '',
							onOk: this.sureScript,
						};
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 导入
			importExcel() {
				this.importModel.flag = true;
				this.importModel.selectedFile = null;
				this.importModel.resultData = null;
			},
			triggerFileSelect() {
				this.$refs.importFileInput.value = null;
				this.$refs.importFileInput.click();
			},
			handleImport(e) {
				this.importModel.selectedFile = e.target.files[0] || null;
			},
			handleUpload() {
				const file = this.importModel.selectedFile;
				if (!file) return;
				const formData = new FormData();
				formData.append('file', file);
				this.importModel.uploading = true;
				importExecutionStandardApi(formData).then((res) => {
					if (res.resultStatus) {
						const data = res.resultData || {};
						if (data.fileUrl) {
							this.importModel.resultData = data;
							this.importModel.resultVisible = true;
						} else {
							this.$message.success(`导入成功，共 ${data.totalCount || 0} 条`);
							this.importModel.flag = false;
							this.getData(this.pageInfo.current);
						}
					} else {
						this.$message.error(res.errorMessage || '导入失败');
					}
				}).catch((err) => {
					console.error(err);
					this.$message.error('导入失败');
				}).finally(() => {
					this.importModel.uploading = false;
				});
			},
			handleDownloadTemplate() {
				const link = document.createElement('a');
				link.href = 'https://oss.chongmi.online/wxapp/importExcel/执行标准模板.xlsx';
				link.download = '执行标准导入模板.xlsx';
				link.click();
			},
			downloadErrorFile(url) {
				const link = document.createElement('a');
				link.href = url;
				link.download = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));
				link.click();
			},
				sureEdit(data) {
				this.deptListError = false;
				this.standardDocError = false;

				let hasCustomError = false;
				if (!this.deptList.length) { this.deptListError = true; hasCustomError = true; }
				if (!this.editModel.standardDocument) { this.standardDocError = true; hasCustomError = true; }

				this.$refs.formRef.validate((valid) => {
					if (valid && !hasCustomError) {
						for (let i = 0; i < this.otherStandList.length; i++) {
							const mod = this.otherStandList[i];
							if (!mod.title || !mod.title.trim()) {
								this.$message.warning('编辑项目未填写完整');
								return;
							}
							if (!mod.content || !mod.content.trim()) {
								this.$message.warning('编辑项目未填写完整');
								return;
							}
						}

						saveExecutionStandardApi({
							otherStand: this.otherStandList.length ? JSON.stringify(this.otherStandList) : null,
							executionStandardId: this.editModel.executionStandardId || 0,
							standardCode: this.editModel.standardCode,
							standardName: this.editModel.standardName,
							sort: this.editModel.sort,
							implementationDate: this.editModel.implementationDate,
							implementationStatus: this.editModel.implementationStatus,
							standardStatus: this.editModel.standardStatus,
							tagId: this.editModel.tagId,
							issuingAuthority: this.deptList.join(';'),
							scopeOfApplication: this.editModel.scopeOfApplication,
							standardDescription: this.editModel.standardDescription,
							physicochemicalIndicators: this.mainList.join(';'),
							customContent: this.editModel.customContent,
							standardDocument: this.editModel.standardDocument,
							obsolescenceDate: this.editModel.obsolescenceDate
						})
						.then((res) => {
							if (res.resultStatus) {
								this.$message.success(
									this.editModel.executionStandardId ? "编辑成功" : "新增成功"
								);
								this.editModel.flag = false;
							} else {
								console.log("res", res);
							}
						})
						.catch((error) => {
							console.log(error);
						})
						.finally(() => {
							this.getData(this.pageInfo.current)
						});
					}
				});
			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.iconUrl,
				};
			},
			sureDelete(record) {
				deleteExecutionStandardApi({
						executionStandardId: record.executionStandardId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData(this.pageInfo.current);
					});
			},
			// 上传标准文件
			handleUploadThumbnail(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						// 文件大小检查：不超过 10MB
						if (file.size > 10 * 1024 * 1024) {
							this.$message.warning('文件大小不能超过 10MB');
							e.target.value = '';
							return;
						}
						this.uploading = true;
						ossUpload(file, '', 'pdf/').then((res) => {
							console.log(res, '文件上传结果')
							this.editModel.standardDocument = res.url;
							this.standardDocError = false;
						}).catch(err => {
							console.log("上传失败", err);
							this.$message.error('文件上传失败')
						}).finally(() => {
							this.uploading = false;
							e.target.value = ''; // 重置 input 值，避免下次选择同名文件不触发 change
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}

	.execution-form .ant-form-item {
		margin-bottom: 6px;
	}
	.execution-form .ant-form-item-label {
		padding-bottom: 0;
		line-height: 28px;
	}
	.execution-form .ant-form-item-control-wrapper {
		line-height: 28px;
	}
	.sort-ghost {
		opacity: 0.5;
		background: #c8ebfb !important;
	}
	/* wangEditor 下拉菜单被裁剪修复 */
	.w-e-toolbar {
		z-index: 99999 !important;
	}
	.w-e-text-container {
		z-index: 1 !important;
	}
</style>
